module.exports = __webpack_public_path__ + "static/media/14_cpc.502fdc4b.svg";